import request from '@/axios'

export const uploadFile = (data: any): Promise<IResponse> => {
  return request.post({
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    url: '/api/File/upload',
    data
  })
}

export const download = (file: any): Promise<IResponse> => {
  return request.get({
    url: file,
    responseType: 'blob'
  })
}
